import React from 'react';
import { XIcon } from 'lucide-react';
const rows = [{
  a: '6 horas × 40 semanas',
  b: '240 horas de tu vida al año'
}, {
  a: '30 cuadernos cada fin de semana',
  b: 'Sábados y domingos de corrección'
}, {
  a: 'Sin protocolo para padres',
  b: 'Mensajes los domingos sin parar'
}, {
  a: 'Sin rutinas instaladas',
  b: 'La misma explicación cada clase'
}, {
  a: 'Mismo ciclo el próximo año',
  b: '240 horas más. Perdidas.'
}];
export function CostSection() {
  return <section className="bg-navy px-4 py-16 text-white" data-id="element-37">
      <div className="mx-auto max-w-2xl" data-id="element-38">
        <h2 className="text-center font-display text-2xl font-black uppercase tracking-tight sm:text-3xl" data-id="element-39">
          ⚖️ ¿Cuánto cuesta no tenerlo?
        </h2>

        <div className="mt-8 overflow-hidden rounded-2xl border border-white/15" data-id="element-40">
          <div className="grid grid-cols-2 bg-white/10 text-xs font-bold uppercase tracking-wide" data-id="element-41">
            <div className="px-4 py-3" data-id="element-42">Sin Método Domingo Libre</div>
            <div className="border-l border-white/15 px-4 py-3 text-magenta" data-id="element-43">
              Costo real
            </div>
          </div>
          {rows.map((r, i) => <div key={r.a} className={`grid grid-cols-2 text-sm ${i % 2 === 0 ? 'bg-white/[0.03]' : 'bg-transparent'}`} data-id="element-44">
              <div className="flex items-start gap-2 px-4 py-3" data-id="element-45">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-magenta" data-id="element-46" />
                <span className="text-white/80" data-id="element-47">{r.a}</span>
              </div>
              <div className="border-l border-white/15 px-4 py-3 font-medium text-white/90" data-id="element-48">
                {r.b}
              </div>
            </div>)}
        </div>

        <div className="mt-10 text-center" data-id="element-49">
          <p className="font-display text-2xl font-black leading-tight sm:text-3xl" data-id="element-50">
            El próximo domingo a las 4 PM tendrás tu semana lista.
          </p>
          <p className="mt-3 text-white/60" data-id="element-51">
            Eso no ocurrió ningún domingo del año pasado.
          </p>
          <p className="mt-4 font-display text-lg font-bold italic text-teal" data-id="element-52">
            — Karito Educa
          </p>
        </div>
      </div>
    </section>;
}